import { useQueries } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import MiniappInfo from "@/features/miniapp/components/miniapp-info";
import MiniappCoursesClient from "@/features/miniapp/components/miniapp-courses-client";
import { VitrinService } from "@/services/vitrin-service";
import TopBar from "@/components/top-bar";
import CircularLoading from "@/components/circular-loading";

export default function MiniAppPage() {
  const { miniappId } = useParams<{ miniappId: string }>();

  const [headerQuery, coursesQuery] = useQueries({
    queries: [
      {
        queryKey: ["vitrin-miniapp-header", miniappId],
        queryFn: () => VitrinService.getMiniAppHeader(miniappId!),
        enabled: Boolean(miniappId),
      },
      {
        queryKey: ["vitrin-miniapp-courses", miniappId],
        queryFn: () =>
          VitrinService.getMiniAppCourses(miniappId!, {
            sort: "-created_at",
            page: 1,
            per_page: 15,
          }),
        enabled: Boolean(miniappId),
      },
    ],
  });

  if (headerQuery.isLoading || coursesQuery.isLoading) {
    return (
      <div className="min-h-svh bg-secondary-background">
        <TopBar title="بازگشت" />
        <CircularLoading />
      </div>
    )
  }

  const header = headerQuery.data?.data;
  const courses = coursesQuery.data?.data ?? [];

  if (!header) {
    return (
      <div className="bg-secondary-background pb-20 min-h-svh lg:pb-8">
        <TopBar title="بازگشت" />
        <div className="p-4 text-center text-default-600">
          اطلاعات برنامک یافت نشد
        </div>
      </div>
    );
  }

  return (
    <div className="bg-secondary-background pb-20 min-h-svh lg:pb-8">
      <TopBar title="بازگشت" />
      <MiniappInfo
        miniapp={header.miniapp}
        usersCount={header.users_count}
        coursesCount={header.courses_count}
      />

      <MiniappCoursesClient
        miniappId={miniappId!}
        categories={header.categories}
        initialCourses={courses}
      />
    </div>
  );
}
